module.exports = __webpack_public_path__ + "img/icon-canister.dc9b1a0e.svg";